import { getStripePayments } from "@invertase/firestore-stripe-payments";
import { app } from "../Firebase/InitFirebase";
import { createCheckoutSession, getCurrentUserSubscriptions } from "@invertase/firestore-stripe-payments";
// SKD:  https://github.com/invertase/stripe-firebase-extensions/blob/next/firestore-stripe-web-sdk/README.md
// Docs: https://docs.stripe.com/api/subscriptions/object?utm_source=chatgpt.com

const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "customers",
  functionsRegion: "us-central1" // might not want this?
});


//https://docs.stripe.com/keys#limit-access

const MONTHLY_PRICE_ID = "price_1SOA9nJVAz3rbONRxZu3ojEi";
const YEARLY_PRICE_ID  = "price_1SOA8KJVAz3rbONR8HUcexuQ";


export async function newCheckout(){
    try{
        console.log("Creating checkout session")
        const session = await createCheckoutSession(payments, {
            price: MONTHLY_PRICE_ID,
        });
        window.location.assign(session.url); 
    }catch(err){
        console.log(err)
    }
}

export async function newYearlyCheckout(){
  try{
    console.log("Creating checkout session")
    const session = await createCheckoutSession(payments, {
        price: YEARLY_PRICE_ID,
    });
    window.location.assign(session.url); 
  }catch(err){
      console.log(err)
  }
}



export async function getCurrentUserSubscriptionStatus(){
   try {
    const subscriptions = await getCurrentUserSubscriptions(payments, {
      status: "active", 
    });
    console.log("status in functions", subscriptions)
    return subscriptions;
  } catch (err) {
    console.error("Error fetching subscriptions:", err);
  }
}


